<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 0a12.01 12.01 0 1 0 12 12c0-6.62-5.38-12-12-12m0 21a9.01 9.01 0 0 1 0-18 9.01 9.01 0 0 1 0 18m6-9.6v1.2c0 .77-.63 1.4-1.4 1.4H7.4A1.4 1.4 0 0 1 6 12.6v-1.2c0-.77.63-1.4 1.4-1.4h9.2c.77 0 1.4.63 1.4 1.4"/></svg>
</template>
